import "./Banglore_cities.css";
const Gurgaon_cities = ()=>{
    return(
        <div className="main_div">
            <h2 className="city">Popular Localities</h2>
            <p className="city">Huda City Center</p>
            <p className="city">Mg Road</p>
            <p className="city">Sector 14</p>
            <p className="city">DLF Phase 3</p>
            <p className="city">Sector 29</p>
            <p className="city">Gurgaon Bus Stand</p>
            <p className="city">Golf Course Road</p>
            <p className="city">Sector 38</p>
            <p className="city">All of Gurgaon</p>
           
        </div>
    )
}
export {Gurgaon_cities}